module.exports = __webpack_public_path__ + "static/media/features1.271f2d4a.png";